import DynamicFormRenderer from '@aims/shared/report-schedules/DynamicFormRenderer';
import { ScheduleFrequencies } from '@aims/shared/report-schedules/constants';
import { Alert, Card, Descriptions, Input, Modal, Tag, Typography } from 'antd';
import React, { useCallback, useState } from 'react';

const { Text } = Typography;
const { TextArea } = Input;

// Previews a template's form as an end user would see it on the user-ui
// fill-out page. Fields are interactive but nothing entered is saved.
function PreviewTemplateFormModal({ template, onClose }) {
  const [formData, setFormData] = useState({});

  const handleFieldChange = useCallback((fieldId, value) => {
    setFormData((prev) => ({ ...prev, [fieldId]: value }));
  }, []);

  return (
    <Modal
      title="Form Preview"
      open={!!template}
      onCancel={onClose}
      afterClose={() => setFormData({})}
      footer={null}
      destroyOnClose
      maskClosable
      width={800}
      style={{ top: 40 }}
      styles={{ body: { maxHeight: 'calc(100vh - 160px)', overflowY: 'auto' } }}
    >
      <Alert
        style={{ marginBottom: 16 }}
        type="info"
        showIcon
        message="This is a preview of the form as end users will see it. Nothing entered here will be saved."
      />
      <Card style={{ marginBottom: 24 }}>
        <Descriptions column={2} bordered size="small">
          <Descriptions.Item label="Template">
            {template?.name || 'Untitled Template'}
          </Descriptions.Item>
          <Descriptions.Item label="Frequency">
            <Tag color={ScheduleFrequencies[template?.frequency]?.color}>
              {ScheduleFrequencies[template?.frequency]?.label ||
                template?.frequency ||
                '-'}
            </Tag>
          </Descriptions.Item>
        </Descriptions>
      </Card>
      {template?.formFields?.length > 0 ? (
        <Card title="Report Form" style={{ marginBottom: 24 }}>
          <DynamicFormRenderer
            formFields={template.formFields}
            formData={formData}
            onChange={handleFieldChange}
          />
        </Card>
      ) : (
        <Card style={{ marginBottom: 24 }}>
          <Text type="secondary">
            No form template has been configured for this report frequency.
          </Text>
        </Card>
      )}
      <Card title="Notes">
        <TextArea
          rows={4}
          placeholder="Add any notes or comments about this report..."
        />
      </Card>
    </Modal>
  );
}

export default PreviewTemplateFormModal;
